import { Component, forwardRef, OnInit } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { TranslateService } from '@ngx-translate/core';
import { ViewService } from '../../../../Services/view.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { UserActionBaseComponent } from '../userAction-base.component';

@Component({
    selector: 'userAction-renameFeatureSystem',
    templateUrl: 'userAction-renameFeatureSystem.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionRenameFeatureSystemComponent) }
    ],
    standalone: false
})
export class UserActionRenameFeatureSystemComponent extends UserActionFeatureSystemsComponent implements OnInit {

  featureSystemsWithMagicFeatureSystems: ValidFeatureSystem[] = [];
  destFeatureSystemName: string = '';
  selectedFeatureSystem: ValidFeatureSystem;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    validFeatureService: ValidFeatureService,
    public systemService: SystemService
  ) {
    super(loginService, macroService, catalogService, validFeatureService);
  }

  async ngOnInit() {
    await super.ngOnInit();
    this.featureSystemsWithMagicFeatureSystems.push(...this.featureSystems);
    ViewService.dropDownFeatureSystemNames.forEach((magicFeatureSystemName) => {
      if (!this.featureSystemsWithMagicFeatureSystems.some((x) => x.name == magicFeatureSystemName)) {
        this.featureSystemsWithMagicFeatureSystems.push(new ValidFeatureSystem(undefined, magicFeatureSystemName));
      }
    });
  }

  public async canStartMacro() : Promise<boolean>{
    if (!this.selectedFeatureSystem) {
      this.systemService.notifyInfo(this.translate.instant('FeatureSystem auswählen'));
      return false;
    }
    if (this.destFeatureSystemName == '') {
      this.systemService.notifyInfo(this.translate.instant('Neuen FeatureSystem-Namen eingeben'));
      return false;
    }
    if (this.destFeatureSystemName == this.selectedFeatureSystem.name) {
      this.systemService.notifyInfo(this.translate.instant('Der neue Name ist gleich dem alten Namen'));
      return false;
    }

    return true;
  }

  createParameterStringAsJsonString() {
    return JSON.stringify({
      source: this.selectedFeatureSystem.name,
      newName: this.destFeatureSystemName
    });
  }

  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.selectedFeatureSystem.name = parsed.source;
      this.destFeatureSystemName = parsed.newName;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
